<template>
  <div class="search-wrapper">
    <i
      class="search-icon hi"
      :class="iconClasses"
    />

    <slot />

    <i
      v-if="showResetButton"
      class="search-clear"
      :class="resetButtonClasses"
      @click="reset"
    />
  </div>
</template>

<script>
export default {
  name: 'AppInputSearch',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    resetButtonClasses: {
      type: String,
      default: 'hi hi-remove',
    },
    showResetButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconClasses() {
      return this.loading ? 'hi-spinner text-blue' : 'hi-search text-lighter';
    },
  },
  methods: {
    reset() {
      this.$emit('reset');
    },
  },
};
</script>
